<app-table
  [res]="connectedUsers"
>
</app-table>